<template>
    <div class="d-block">
        <div class="row">
            <div class="col-md-2">
                <ul id="oneOrderTabs" role="tablist" class="parent_item_block d-none d-sm-block nav fa-ul order-show-one-menu">
                    <li class="parent_item pb-0">
                        <a class="nav-link active" data-toggle="tab" role="tab" aria-controls="order-details" aria-selected="true" href="#order-details"><span class="fa-li"><i class="fas fa-chevron-right"></i></span>Карточка</a>
                        <ul class="ml-0 mt-3 mb-4">
                            <li class="child_item" v-if="detailedItem.set_services_ids.includes(22)">
                                <a class="nav-link" data-toggle="tab" role="tab" aria-controls="order-service-22" aria-selected="false" href="#order-service-22">Таможенное оформление</a>
                            </li>
                            <li class="child_item" v-if="detailedItem.set_services_ids.includes(24)">
                                <a class="nav-link" data-toggle="tab" role="tab" aria-controls="order-service-24" aria-selected="false" href="#order-service-24">Сертификация</a>
                            </li>
                            <li class="child_item" v-if="detailedItem.set_services_ids.includes(25)">
                                <a class="nav-link" data-toggle="tab" role="tab" aria-controls="order-service-25" aria-selected="false" href="#order-service-25">Консалтинг и сопутсвующие услуги</a>
                            </li>
                            <li class="child_item" v-if="detailedItem.set_services_ids.includes(23)">
                                <a class="nav-link" data-toggle="tab" role="tab" aria-controls="order-service-23" aria-selected="false" href="#order-service-23">Логистика</a>
                            </li>
                            <li class="child_item" v-if="detailedItem.set_services_ids.includes(75)">
                                <a class="nav-link" data-toggle="tab" role="tab" aria-controls="order-service-75" aria-selected="false" href="#order-service-75">ПНК</a>
                            </li>
                            <li class="child_item" v-if="detailedItem.set_services_ids.includes(76)">
                                <a class="nav-link" data-toggle="tab" role="tab" aria-controls="order-service-76" aria-selected="false" href="#order-service-76">СВХ</a>
                            </li>
                            <li class="child_item" v-if="detailedItem.set_services_ids.includes(77)">
                                <a class="nav-link" data-toggle="tab" role="tab" aria-controls="order-service-77" aria-selected="false" href="#order-service-77">Страхование</a>
                            </li>
                        </ul>
                    </li>
                    <hr>
                    <li class="parent_item nav-item" v-if="!detailedItem.short_order">
                        <a
                            class="nav-link"
                            data-toggle="tab"
                            role="tab"
                            aria-controls="order-documents"
                            aria-selected="false"
                            href="#order-documents"
                            @click="requestDocuments = !requestDocuments"
                        >
                            <span class="fa-li"><i class="fas fa-chevron-right"></i></span>
                            Документы
                        </a>
                    </li>
                    <li class="parent_item pb-0" v-if="detailedItem.reference_order_type_id == 2">
                        <a class="nav-link" data-toggle="tab" role="tab" aria-controls="finance" aria-selected="false" href="#finance"><span class="fa-li"><i class="fas fa-chevron-right"></i></span> Финансы</a>
                        <ul class="ml-0 mt-3 mb-4">
                            <li class="child_item">
                                <a class="nav-link" id="financeTabInOneOrder" data-toggle="tab" role="tab" aria-controls="order-finance" aria-selected="false" href="#order-finance">Счета</a>
                            </li>
                            <li class="child_item">
                                <a class="nav-link" data-toggle="tab" role="tab" aria-controls="order-finance-requests" aria-selected="false" href="#order-finance-requests">Запросы</a>
                            </li>
                        </ul>
                    </li>
                    <li class="parent_item nav-item">
                        <a
                            class="nav-link"
                            data-toggle="tab"
                            href="#order-change-history"
                            role="tab"
                            aria-controls="order-change-history"
                            aria-selected="false"
                            @click="changeLoadOrder = !changeLoadOrder"
                        >
                            <span class="fa-li"><i class="fas fa-chevron-right"></i></span>
                            История
                        </a>
                    </li>
                    <li class="parent_item nav-item">
                        <a
                            class="nav-link"
                            data-toggle="tab"
                            href="#order-change-tasks"
                            role="tab"
                            aria-controls="order-change-tasks"
                            aria-selected="false"
                            @click="changeLoadTaskList = !changeLoadTaskList"
                        >
                            <span class="fa-li"><i class="fas fa-chevron-right"></i></span>
                            Задачи
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-md-10">
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="order-details">
                        <tsoft-order-details
                            :detailedItemIndex="detailedItemIndex"
                            :detailedItem="detailedItem"
                            @closeOrder="closeOrder"
                            @changeOrderStatus="changeOrderStatus"
                            @changeOrderStatusByID="changeOrderStatusByID"
                            @changeCreatorUserId="changeCreatorUserId"
                            @makeOrderSupplyByID="makeOrderSupplyByID"
                            @openServiceDistributionModal="openServiceDistributionModal"
                        ></tsoft-order-details>
                    </div>
                    <div class="tab-pane fade" id="order-service-22" v-if="detailedItem.set_services_ids.includes(22)">
                        <tsoft-order-service-details
                            :order_id="detailedItem.id"
                            :reference_service_id="22"
                            @setServiceInfo="setServiceInfo"
                        ></tsoft-order-service-details>
                    </div>
                    <div class="tab-pane fade" id="order-service-24" v-if="detailedItem.set_services_ids.includes(24)">
                        <tsoft-order-service-details
                            :order_id="detailedItem.id"
                            :reference_service_id="24"
                            @setServiceInfo="setServiceInfo"
                        ></tsoft-order-service-details>
                    </div>
                    <div class="tab-pane fade" id="order-service-25" v-if="detailedItem.set_services_ids.includes(25)">
                        <tsoft-order-service-details
                            :order_id="detailedItem.id"
                            :reference_service_id="25"
                            @setServiceInfo="setServiceInfo"
                        ></tsoft-order-service-details>
                    </div>
                    <div class="tab-pane fade" id="order-service-23" v-if="detailedItem.set_services_ids.includes(23)">
                        <tsoft-order-service-details
                            :order_id="detailedItem.id"
                            :reference_service_id="23"
                            @setServiceInfo="setServiceInfo"
                        ></tsoft-order-service-details>
                    </div>
                    <div class="tab-pane fade" id="order-service-75" v-if="detailedItem.set_services_ids.includes(75)">
                        <tsoft-order-service-details
                            :order_id="detailedItem.id"
                            :reference_service_id="75"
                            @setServiceInfo="setServiceInfo"
                        ></tsoft-order-service-details>
                    </div>
                    <div class="tab-pane fade" id="order-service-76" v-if="detailedItem.set_services_ids.includes(76)">
                        <tsoft-order-service-details
                            :order_id="detailedItem.id"
                            :reference_service_id="76"
                            @setServiceInfo="setServiceInfo"
                        ></tsoft-order-service-details>
                    </div>
                    <div class="tab-pane fade" id="order-service-77" v-if="detailedItem.set_services_ids.includes(77)">
                        <tsoft-order-service-details
                            :order_id="detailedItem.id"
                            :reference_service_id="77"
                            @setServiceInfo="setServiceInfo"
                        ></tsoft-order-service-details>
                    </div>
                    <div class="tab-pane fade" id="order-documents">
                        <h5>Документы по заказу #{{detailedItem.id}}</h5>
                        <tsoft-show-edit-documents
                            :orderId="detailedItem.id"
                            :companyId="detailedItem.company_id"
                            :requestDocuments.sync="requestDocuments"
                            :updateListDocument="singleOrMultiDocuments"
                            @clearDocumentList="clearDocumentList"
                        />
                        <tsoft-create-documents
                            :orderId="detailedItem.id"
                            :companyId="detailedItem.company_id"
                            :needMultiUploadDocuments="true"
                            @updateViewDocument="documentOutput"
                            @documentLoaded="onCloseSidePanelLoadingDocument"
                        />
                        <div class="document_view_order" v-if="detailedItem.company_id && documentIdsFromCompany.length > 0">
                            <h5>Документы по услугам в компании</h5>
                            <tsoft-show-edit-documents
                                :companyId="detailedItem.company_id"
                                :referenceDocumentTypeIds="documentIdsFromCompany"
                                :requestDocuments="true"
                                :updateDocumentList="documentIdsFromCompany.length"
                                :noActions="true"
                            />
                        </div>
                    </div>
                    <div class="tab-pane fade" id="order-finance">
                        <h5 class="mb-4">Счета по заказу #{{detailedItem.id}}</h5>
                        <tsoft-finance-finder-creator
                            id="invoiceToOrder"
                            :exportXLSX="`Счета по заказу #${detailedItem.id}`"
                            :order_id="detailedItem.id"
                            :company_id="detailedItem.company_id"
                            :allowed_services="detailedItem.services"
                            :full_order="detailedItem"
                            :additionalGetParameter="`&order_id=${detailedItem.id}`"
                            :typeOfTableFilter="'finance'"
                            @refreshFinanceRequests="onRefreshFinanceRequests"
                        >
                        </tsoft-finance-finder-creator>
                    </div>
                    <div class="tab-pane fade" id="order-finance-requests">
                        <h5 class="mb-4">Финансовые запросы по заказу #{{detailedItem.id}}</h5>
                        <tsoft-finance-requests-by-parameters
                            :key="onRefreshFinanceRequestsKey"
                            :additionalGetParameter="`&order_id=${detailedItem.id}`"
                            :isNeedCreate="false"
                        />
                    </div>
                    <div class="tab-pane fade" id="order-change-history">
                        <h5 class="mb-4">История изменений по заказу #{{detailedItem.id}}</h5>
                        <tsoft-change-history
                            :changeHistoryId.sync="detailedItem.id"
                            :changeLoadOrder.sync="changeLoadOrder"
                        />
                    </div>
                    <div class="tab-pane fade" id="order-change-tasks">
                        <h5 class="mb-4">Задачи по заказу #{{detailedItem.id}}</h5>
                        <tsoft-history-task
                            :modelName="'order_id'"
                            :modelId="detailedItem.id"
                            :changeLoadTaskList.sync="changeLoadTaskList"
                        />
                    </div>
                </div>
            </div>
        </div>
        <tsoft-order-service-distribution
            :isOpenServiceDistributionModal.sync="isOpenServiceDistributionModal"
            :editIndex="detailedItemIndex"
            :editedItem="detailedItem"
            :modalKey="'orderShowOne'"
            @updateOneOrder="updateOneOrder"
        ></tsoft-order-service-distribution>
    </div>
</template>

<script>
    import {
        SERVICE_TO_DOCUMENT,
        API_ORDERS
    } from "../../constants"

    import tsoftOrderDetails from './OrderDetails'
    import tsoftOrderServiceDetails from './OrderServiceDetails'
    import tsoftOrderServiceDistribution from "./OrderServiceDistribution"

    import tsoftChangeHistory from '../logs/ChangeHistory'
    import tsoftFinanceFinderAndCreator from '../finance/FinanceFinderAndCreator'
    import tsoftFinanceRequestsByParameters from '../finance/FinanceRequestsByParameters'

    import { mixinDocuments } from '../../mixins/mixinDocuments'

    import {
        orderMethods
    } from '../../mixins'

    export default {
        components: {
            "tsoft-order-details": tsoftOrderDetails,
            "tsoft-order-service-details": tsoftOrderServiceDetails,
            'tsoft-change-history': tsoftChangeHistory,
            'tsoft-finance-finder-creator': tsoftFinanceFinderAndCreator,
            'tsoft-finance-requests-by-parameters': tsoftFinanceRequestsByParameters,
            'tsoft-order-service-distribution': tsoftOrderServiceDistribution,
        },
        props: {
            detailedItemIndex: { type: Number, required: false, default: -1 },
            detailedItem: { type: Object, required: true },
        },
        mixins: [
            mixinDocuments,
            orderMethods
        ],
        data() {
            return {
                requestDocuments: false,    //sign for document output by order
                changeLoadOrder: false,
                changeLoadTaskList: false,
                onRefreshFinanceRequestsKey: 0, // key of finance requests refreshing
                documentIdsFromCompany: [],
                tableApiUrl: API_ORDERS,
            }
        },
        mounted() {
            $(document).ready(function() {
                $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                    e.target // newly activated tab
                    e.relatedTarget // previous active tab

                    $('.order-show-one-menu a[data-toggle="tab"]').removeClass('active');
                    if (e.relatedTarget) {
                        $(e.relatedTarget).removeClass('active');
                    }

                    $(e.target).addClass('active');
                })
            })

            this.setDocumentIdsFromCompany()
        },
        methods: {
            onCloseSidePanelLoadingDocument(value) {
                if(value == true){
                    this.checkedLoadDocument = false
                }
            },
            onRefreshFinanceRequests() {
                this.onRefreshFinanceRequestsKey += 1
            },
            closeOrder(index) {
                this.$emit('closeOrder', index)
            },
            changeOrderStatus(index, newStatus = 361) {
                this.$emit('changeOrderStatus', index, newStatus)
            },
            changeOrderStatusByID(id, newStatus = 361) {
                this.$emit('changeOrderStatusByID', id, newStatus)
            },
            changeCreatorUserId(id, data, index) {
                this.$emit('changeCreatorUserId', id, data, index)
            },
            setDocumentIdsFromCompany() {
                this.documentIdsFromCompany = []
                this.detailedItem.set_services_ids.forEach((id, index) => {
                    this.documentIdsFromCompany.push(SERVICE_TO_DOCUMENT[id])
                })
            },
            setServiceInfo(service_id, data) {
                if (!this.detailedItem.services_info) {
                    this.$set(this.detailedItem, 'services_info', {})
                }
                this.detailedItem.services_info[service_id] = data
            },
            async makeOrderSupplyByID(id) {
                this.detailedItem.loading = true
                let message = await this.finalFormValidate(this.detailedItem)
                const updateFields = {
                    reference_order_type_id: 2,
                    reference_status_id: 359,
                    makingOrderSupply: true
                }

                if (message.length == 0) {
                    this.updateAnyOrder(id, updateFields)
                } else {
                    this.detailedItem.loading = false
                    const h = this.$createElement
                    const vNodesMsg = h(
                        'ul',
                        message
                    )
                    this.$bvToast.toast([vNodesMsg], {
                        title: `Невозможно перевести заказ #${this.detailedItem.id} в Поставку, заполните все необходимые поля`,
                        variant: 'warning',
                        solid: true,
                        noAutoHide: true
                    })
                }
            },
            openServiceDistributionModal() {
                this.isOpenServiceDistributionModal = true
            },
            updateOneOrder(index) {
                this.updateOneOrderByIndex(index)
            }
        }
    }
</script>
